import React from 'react';
import PublicLayout, { PublicHero, PublicButton } from '../../components/layout/PublicLayout';
import { motion } from 'framer-motion';
import { ShieldCheck, BookOpenCheck, Sparkles, Lock } from 'lucide-react';

const features = [
  { icon: BookOpenCheck, title: 'Purpose-built for legal work', desc: 'Practical tools designed around how legal professionals actually work with documents and matters.' },
  { icon: ShieldCheck, title: 'Privacy-first by design', desc: 'Security, access control and auditability are foundational, not afterthoughts.' },
  { icon: Sparkles, title: 'A growing ecosystem', desc: 'Independent products, brought together under one trusted, unified experience.' },
  { icon: Lock, title: 'You stay in control', desc: 'Clear choices over your account and your data, with straightforward support.' },
];

const Home = () => (
  <PublicLayout title="AI-Powered Legal Platform" description="VSKR Legal — a secure legal-technology ecosystem for legal professionals. Explore LIOS, our document intelligence product.">
    <PublicHero
      eyebrow="Legal Technology Ecosystem"
      title={<>The trusted home for <span className="text-[#2D8CFF]">modern legal work</span>.</>}
      subtitle="VSKR Legal builds secure, practical tools for legal professionals. Our first product, LIOS, brings intelligent document management to your practice.">
      <PublicButton to="/products/lios" testid="home-explore-lios">Explore LIOS</PublicButton>
      <PublicButton to="/login" variant="secondary" testid="home-signin">Sign In</PublicButton>
    </PublicHero>

    <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f, i) => (
          <motion.div key={f.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="glass-card p-6 rounded-2xl">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 bg-[#2D8CFF]/15 text-[#2D8CFF]"><f.icon className="w-5 h-5" /></div>
            <h3 className="font-semibold mb-1.5">{f.title}</h3>
            <p className="text-sm opacity-70 leading-relaxed">{f.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20">
      <div className="glass-card rounded-3xl p-8 lg:p-12 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-72 h-72 rounded-full opacity-20" style={{ background: 'radial-gradient(circle, rgba(45,140,255,0.5), transparent 70%)' }} />
        <div className="relative z-10 max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-wider text-[#D4AF37]">Featured Product</span>
          <h2 className="text-2xl md:text-3xl font-bold mt-2">LIOS — intelligent document management</h2>
          <p className="mt-3 text-sm md:text-base opacity-75 leading-relaxed">
            A focused workspace for reading, organising and working with legal documents. LIOS is currently in a
            testing stage as we prepare it for wider availability.
          </p>
          <div className="mt-6"><PublicButton to="/products/lios" testid="home-lios-cta">Learn about LIOS</PublicButton></div>
        </div>
      </div>
    </section>
  </PublicLayout>
);

export default Home;
